// ========================================
// ライブラリ / プラグイン
// ========================================
import 'swiper/css';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// ========================================
// 機能モジュール
// ========================================
import { header } from './header.js';
// import { parallax } from './parallax.js';
import { slider } from './slider.js';
import { trigger } from './trigger.js';

// ========================================
// プラグイン登録
// ========================================
gsap.registerPlugin(ScrollTrigger);

// ========================================
// 初期化
// ========================================
export function init() {
  header();
  trigger();
  // parallax();
  slider();
}

// シングル / PDFボタンの選択範囲を変更
document.addEventListener('DOMContentLoaded', function () {
  const pdfButtons = document.querySelectorAll('.wp-block-button.p-post-pdf');

  pdfButtons.forEach(function (button) {
    const link = button.querySelector('a');
    if (link) {
      button.style.cursor = 'pointer';
      button.addEventListener('click', function (e) {
        if (e.target !== link) {
          link.click();
        }
      });
    }
  });
});

// TOP / タグ検索のMORE / 表示非表示
document.addEventListener('DOMContentLoaded', function () {
  const searchElement = document.querySelector('.js-search');
  const searchButton = document.querySelector('.js-search-button');

  if (!searchElement || !searchButton) return;

  function checkHeight() {
    const scrollHeight = searchElement.scrollHeight;
    const maxHeight = window.innerWidth < 768 ? 72 : 78; // tab2以下で80px、それ以上78px
    if (scrollHeight > maxHeight) {
      searchElement.style.height = maxHeight + 'px';
      searchElement.style.overflow = 'hidden';
      searchButton.style.display = 'block';
    } else {
      searchElement.style.height = 'auto';
      searchElement.style.overflow = 'visible';
      searchButton.style.display = 'none';
    }
  }

  checkHeight();
  window.addEventListener('resize', checkHeight);

  searchButton.addEventListener('click', function () {
    searchElement.style.height = 'auto';
    searchElement.style.overflow = 'visible';
    searchButton.style.display = 'none';
  });
});
init();
